import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { isNil } from '@web/utils';
import { EntryNotFoundException } from '@web/common';
import { SelectItem } from '@web/shared/ui';
import { RefundType } from '../enums/refund-type';

@Injectable({
  providedIn: 'root',
})
export class RefundTypeProviderService {
  private readonly entries = new Map<RefundType, string>([
    [RefundType.Partial, 'Częściowy'],
    [RefundType.Full, 'Całkowity'],
  ]);

  public labelFor(type: RefundType): Observable<string> {
    const result = this.entries.get(type);

    if (isNil(result)) {
      throw new EntryNotFoundException(`The entry for "${type}" is not found.`);
    }

    return of(result);
  }

  public selectItems(): Observable<SelectItem<RefundType>[]> {
    return of(
      Array.from(this.entries.entries()).map(
        ([type, label]) => new SelectItem<RefundType>(label, type),
      ),
    );
  }
}
